export default {
  '组织结构列表':'組織結構列表',
  '请输入名称\代码':'請輸入名稱\代碼',
  '管理成员':'管理成員',
  '组织结构名称':'組織結構名稱',
  '上级组织':'上級組織',
  '组织代码':'組織代碼',
  '添加成员':'添加成員',
  '组织结构':'組織結構',
  '组织结构代码需为两位':'組織結構代碼需為兩位',
  '新增组织结构':'新增組織結構',
  '编辑组织结构':'編輯組織結構',
  '确认要删除该组织结构：{departmentName}？':'確認要刪除該組織結構：{departmentName}？',
  '取消全部选中':'取消全部選中',
  '是否确认批量移除{selectedUser}名成员？':'是否確認批量移除{selectedUser}名成員？',
  '是否确认移除成员{accountName}？':'是否確認移除成員{accountName}？',
  '确认要删除该机构：{tenantOrgName}？':'確認要刪除該機構：{tenantOrgName}？',  
  '确认要停用该机构：{tenantOrgName}？':'確認要停用該機構：{tenantOrgName}？',  
  '确认要启用该机构：{tenantOrgName}？':'確認要啓用該機構：{tenantOrgName}？',  
  '停用该机构将会停用下层级机构':'停用該機構將會停用下層級機構',  
}    